﻿'use strict';

angular.module('ntmApp')
  .controller('calendarButtonDialogController', ['$scope', 'data', '$uibModalInstance', 'EditForm', 'FormService', 'ListGridConstants',
      function ($scope, data, $uibModalInstance, EditForm, FormService, ListGridConstants) {

          $scope.close = function () {
              $uibModalInstance.dismiss();
          };

          function onDataUpdatedMethod() {
              $uibModalInstance.dismiss();

              data.updateMethod();
          }

          function prepareFormData(result) {

              result.generalPageSection.forEach(function (section) {
                  section.sectionAttributes.forEach(function (field) {
                      if (field.fieldName === data.calendarButton.dateField) {
                          if (data.clickedButtonsDate) {
                              section.model[field.fieldName] = new Date(data.clickedButtonsDate);
                          }
                      }
                  });
              });

              result.onDataUpdatedMethod = onDataUpdatedMethod;
          }

          function initData() {
			  
			  var requestData = {
			      id: data.calendarButton.htmlPageId
		      };

              FormService.GetForm(requestData).then(function (result) {
				  
				  result.data.hideCancelBtn = true;				  
				  result.data.action = ListGridConstants.Operation.INSERT;
				  result.data.pageType = ListGridConstants.SectionType.Calendar;

                  $scope.editForm = new EditForm(result.data);

                  prepareFormData(result.data);

                  $scope.dataLoaded = true;
              });

          }

          initData();

      }]);